import { MinimalLiveAudioSkinElement } from '../../presets/live-audio/minimal-skin';
import { safeDefine } from '../../registration/safe-define';
import '../../internal/skins/minimal-live-audio/register';

safeDefine(MinimalLiveAudioSkinElement);
